<template>
  <label class="checkbox" :for="value" :class="disabled ? 'checkbox__disabled' : ''">
    <span class="checkbox__text" v-if="!textHidden">{{ text }}</span>
    <input type="checkbox" :id="value"  @click="clickCheckbox" :checked="checked" :disabled="disabled">
    <span class="checkbox__check"></span>
  </label>
</template>

<script>
  export default {
    name: 'Checkbox',
    props: {
      text: String,
      value: String,
      checked: Boolean,
      disabled: Boolean,
      textHidden: Boolean
    },
    methods: {
      clickCheckbox () {
        let self = this
        if (self.disabled !== true) {
          self.$emit('change', { text: self.value, value: self.value, checked: self.checked })
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../styling/styling.scss';

  .checkbox {
    height: rem(25);
    display: block;
    cursor: pointer;
    user-select: none;
    position: relative;
    line-height: rem(25);
    -ms-user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;

    &__check {
      width: rem(16);
      height: rem(16);
      left: 0;
      position: absolute;
      border-radius: rem(2);
      top: calc(50% - #{rem(8)});
      background-color: transparent;
      border: rem(1) solid $dark-grey-background;

      &:after {
        width: 4px;
        height: 8px;
        top: 1px;
        left: 4px;
        content: '';
        display: none;
        position: absolute;
        border: solid $medium-grey-background;
        border-width: 0 2px 2px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
      }
    }

    &__text {
      font-weight: 400;
      font-size: rem(13);
      margin-left: rem(25);
      color: $medium-grey-font;
    }

    input {
      width: 0;
      height: 0;
      opacity: 0;
      cursor: pointer;
      position: absolute;

      &:checked ~ .checkbox__check {
        background-color: $white!important;
        border-color: $secondary-border-color;
      }

      &:checked ~ .checkbox__check:after {
        display: block;
        border-color: $medium-grey-font;
      }
    }

    &__disabled {
      cursor: not-allowed;
      color: $dark-grey-background;

      .checkbox__text { color: $dark-grey-background; }

      .checkbox__check {
        background-color: $white;
        border-color: $disabled-border-color;
      }
    }

    &:hover {

      .checkbox__text { color: $dark-grey-font; }

      &.checkbox__disabled {

        .checkbox__text { color: $dark-grey-background; }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// node_modules/pro4all-ui/ui-kit/components/Checkbox.vue